"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRewardDate = void 0;
var config_1 = require("@pbl/pbl-react-core/lib/config/config");
var DateTimeFormatter_1 = __importDefault(require("@pbl/pbl-react-core/lib/utils/DateTimeFormatter"));
var TimeUtil_1 = require("@pbl/pbl-react-core/lib/utils/TimeUtil");
var formatRewardDate = function (dateFormat, tbd, date) {
    var _a;
    return date
        ? !!((_a = config_1.react_core_config.internalConfig.dateFormatter) === null || _a === void 0 ? void 0 : _a.drawStartEndDateFormat)
            ? DateTimeFormatter_1.default.getFormattedDateFromDateString(dateFormat, date)
            : (0, TimeUtil_1.formatLongMonthDayCommaYear)(date)
        : tbd;
};
exports.formatRewardDate = formatRewardDate;
//# sourceMappingURL=rewardDatesUtil.js.map